import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const correctiveActionSubjectsAdapter = getAdapter();

const correctiveActionSubjectsSlice = createSlice({
  name: 'correctiveActionSubjects',
  initialState: correctiveActionSubjectsAdapter.getInitialState(),
  reducers: {
    setCorrectiveActionSubjects: (state, { payload: { correctiveActionSubjects } }) => {
      correctiveActionSubjectsAdapter.setAll(state, correctiveActionSubjects);
    },
  },
});

const selectors = correctiveActionSubjectsAdapter.getSelectors(({ correctiveActionSubjects }) => correctiveActionSubjects);

export const getCorrectiveActionSubjects = (state) => selectors.selectAll(state);

export const {
  setCorrectiveActionSubjects,
} = correctiveActionSubjectsSlice.actions;

export default correctiveActionSubjectsSlice.reducer;
